
export enum ProjectResearchType {
    Retrospective = "Retrospective",
    Prospective = "Prospective",
}

